import React from "react";
import nilcomplianceandprocedures from "../../../Assets/nilcomplianceandprocedures.jpeg";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import "../../Informations/Information.css";
const NILComplianceAndProcedures = () => {
  return (
    <>
      <Header />
      <div className="page-main-container-aboutus">
        <div className="nill-img-text-hone">
          <div className="nill-img-aboutus">
            <img src={nilcomplianceandprocedures} alt="" />
          </div>
          <div>
            <h2 className="htwo-heading-aboutus">
              NIL Compliance & Procedures
            </h2>
            <p className="text-aboutus">
              All NIL activities must be conducted through the institution’s
              approved NIL platform or collective. Athlete engagements may
              include documented NIL services such as promotional appearances,
              social media posts, or other activities that reflect fair market
              value. Compensation cannot be tied to athletic performance,
              playing time, enrollment decisions, or recruiting inducements, and
              no pay-for-play arrangements are permitted.
            </p>
            <p className="text-aboutus">
              Each NIL agreement must be disclosed in the school’s compliance
              portal by the earlier of:
            </p>
            <ul
              className="text-aboutus"
              style={{ paddingLeft: "1.5rem", listStyleType: "disc" }}
            >
              <li>The deadline required by applicable state law</li>
              <li>The deadline set by institutional policy</li>
              <li>
                Thirty days after execution, consistent with NCAA Division I
                rules
              </li>
            </ul>
            {/* <p className="text-aboutus">
              Supporters may contribute any amount; contributions meeting IRS or
              institutional reporting thresholds may require additional
              verification or tax documentation.
            </p> */}
            <p className="text-aboutus">
              Policies governing NIL activities, including the use of
              institutional trademarks, logos, or uniforms, vary by state,
              conference, and school. Written consent from the athlete (and a
              separate licensing agreement with the institution, where
              applicable) is required before any use of Name, Image, or Likeness
              or school marks. All parties are responsible for ensuring full
              compliance with NCAA regulations, state law, and institutional
              guidelines.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default NILComplianceAndProcedures;

// import React from 'react'
// import nilcomplianceandprocedures from "../../../Assets/nilcomplianceandprocedures.jpeg"
// import Header from '../../Header/Header'
// import Footer from '../../Footer/Footer'
// import "../../Informations/Information.css"
// const NILComplianceAndProcedures = () => {
//     return (
//         <>
//             <Header />
//             <div className='page-main-container-aboutus'>
//                 <div className='nill-img-text-hone'>
//                     <div className='nill-img-aboutus'>
//                         <img src={nilcomplianceandprocedures} alt="" />
//                     </div>
//                     <div>
//                         <h2 className='htwo-heading-aboutus'>NIL Compliance & Procedures</h2>
//                         <p className='text-aboutus'>
//                             All contributions are processed through the institution’s approved NIL platform or collective. Funds may be transferred to student athletes only in exchange for documented NIL services (for example, promotional appearances or social media posts) that reflect fair market value. Compensation cannot be conditioned on athletic performance, playing time, enrollment decisions, or recruiting inducements, and no pay for play arrangements are permitted.
//                         </p>
//                         <p className='text-aboutus'>
//                             Each NIL agreement must be disclosed in the school’s compliance portal by the earlier of:
//                         </p>
//                         <ul className='text-aboutus' style={{ paddingLeft: '1.5rem', listStyleType: 'disc' }}>
//                             <li>the deadline required by applicable state law,</li>
//                             <li>the deadline set by institutional policy, or</li>
//                             <li>thirty days after execution, consistent with NCAA Division I rules.</li>
//                         </ul>
//                         <p className='text-aboutus'>
//                             Supporters may contribute any amount; contributions meeting IRS or institutional reporting thresholds may require additional verification or tax documentation.
//                         </p>
//                         <p className='text-aboutus'>
//                             Policies governing NIL activities, including use of institutional trademarks, logos, or uniforms, vary by state, conference, and school. Written consent from the student athlete (and a separate licensing agreement with the institution, where applicable) is required before any use of Name, Image, or Likeness or school marks. All parties are responsible for ensuring full compliance with NCAA regulations, state law, and institutional guidelines.
//                         </p>
//                     </div>

//                 </div>
//             </div>
//             <Footer />
//         </>
//     )
// }
// export default NILComplianceAndProcedures
